export enum ProductUnitType {
    BaseUnit = <any>"14ad41d7-5fbb-4af8-95d6-728cba4cc029",
    InnerBoxUnit = <any>"1b7e0f18-3d77-4ac6-a40e-9109e6877f36",
    TransportUnit = <any>"886592b7-0f74-47f6-ad79-6d71e6f04228",
    InnerBoxUnitSecond = <any>"17ede2b9-4902-470f-bea4-e0ed1eb1125f",
    Pallet = <any>"e02cf57d-85a4-4f49-95cc-f5834fc58993",
    Display = <any>"c5ad2390-5b03-4670-a5f2-30d4c914a252"
}
(ProductUnitType as any).__typeName = "ProductUnitType";